module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-5-986c1b9252cfd8977eeb8f1bd10b91ed.svg";